const dayMs = require('../constants/day-ms')

/**
 * Check if a given date is within one week from today
 * @param {Date} d - Date to test
 * @returns {boolean}
 */
const withinOneWeekFromToday = d => {
  const now = Date.now()
  const dTime = d.getTime()

  const todayStartMS = now - (now % dayMs)
  const nextWeekStartMS = todayStartMS + dayMs * 6
  const dStartMS = dTime - (dTime % dayMs)

  if (todayStartMS <= dStartMS && nextWeekStartMS >= dStartMS) {
    return true
  }
  return false
}

module.exports = withinOneWeekFromToday
